"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const Paths_1 = require("../../constants/Paths");
const cart_1 = require("../../helper/cart");
const history_1 = require("../../helper/history");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
class AssetsOfferCheckout extends react_1.default.Component {
    loading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            orderedAt: mobx_1.computed,
            offer: mobx_1.computed,
        });
    }
    get orderedAt() {
        return this.offer.orderedAt ?? null;
    }
    get offer() {
        return this.props.offer;
    }
    render() {
        if (null === this.orderedAt) {
            return (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.CART_UPDATE] },
                react_1.default.createElement(Button_1.default, { className: 'znd-offers-table__checkout znd-offers-table__checkout--button', disabled: this.loading, icon: Zupicons_1.default.shoppingCart, loading: this.loading, size: ButtonSize_1.default.small, text: this.props.t('myassets.offer.checkout') ?? '', variant: ButtonVariant_1.default.secondary, onClick: this.addToCart })));
        }
        return (react_1.default.createElement("div", { className: "znd-offers-table__checkout znd-offers-table__checkout--ordered", "data-tag": "allowRowEvents" }, this.offer.isAdvancedPayment
            ? this.props.t('myassets.offer.state.pending')
            : this.props.t('myassets.offer.state.paid')));
    }
    addToCart() {
        this.loading = true;
        ShopwareCart_1.default.addLineItems([{ softwareOfferId: this.offer.offerId, type: ecommerce_1.LineItemTypeEnum.ZkpSoftwareOffer }])
            .then(() => {
            (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT);
        })
            .catch((response) => (0, cart_1.handleAddToCartErrorResponse)(response))
            .finally(() => {
            this.loading = false;
        });
    }
}
__decorate([
    bind_decorator_1.default
], AssetsOfferCheckout.prototype, "addToCart", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsOfferCheckout)));
